import React from "react";
import { Box } from "@mui/material";
import { assetImages } from "../../constants/assets";

const Logo = () => {
  return (
    <Box
      component="img"
      src={assetImages.logo} // Hardcoded logo source
      alt="Logo"
      display="flex"
      justifyContent="left"
      sx={{
        width: 70,
        // height: 50,
        mb: 4,
      }}
    />
  );
};

export default Logo;
